import React, { Component } from 'react';
import Chart_Bar from '../../../Part_Sample/Chart_Bar';
import { makeTimeString } from '../../../Common/Common';

export default class Total_Hourly_Bar_Chart extends Component {
	constructor(props) {
		super(props);

		this.state = {

		}

		this.chart = React.createRef();
	}

	getChartEnergyTotalHourly = () => {
		let data = [];
		// eg. [['x', '0318 23:00', '0319 00:00',...],['hourly_data', '15.8', '2.3',...]]
		let timeseries = ['x'];
		let hourly_data = [this.props.receiver.getString('hourly_data')];

		let now = new Date();
		now.setDate(now.getDate() - 1);
		now.setHours(now.getHours() + 1);

		for (let i = 0; i < 24; i++) {
			let timestring = makeTimeString(now.getMonth() + 1) + makeTimeString(now.getDate()) + ' ' + now.getHours() + ':00'
			timeseries.push(timestring);
			let hourly_index = now.getHours();
			hourly_data.push(this.props.data.total_energy.hourly[hourly_index]);
			now.setHours(now.getHours() + 1);
		}

		data.push(timeseries);
		data.push(hourly_data);
		return data;
	}

	refreshChart = () => {
		this.chart.current.loadChart();
	}

	render() {
		let energy_chart_data = this.getChartEnergyTotalHourly();

		let chart_width = this.props.width - 40;
		let chart_height = chart_width / 3 * 2;

		let is_landscape = (this.props.width >= this.props.height)
		if (is_landscape) {
			chart_height = this.props.width / 3;
			if (chart_height > this.props.height - 240 && chart_height > 250) chart_height = this.props.height - 240;
		}

		let colors = {};
		colors[this.props.receiver.getString('hourly_data')] = window.app.state.colours.chart_bar;

		return (
			<Chart_Bar
				id={'past_24_hr'}
				ref={this.chart}
				title={this.props.receiver.getString('past_24_hr') + ' (kWh)'}
				chart_width={chart_width}
				chart_height={chart_height}
				data={energy_chart_data}
				receiver={this.props.receiver}
				colors={colors}
			/>
		)
	}
}